import React, { useState } from 'react';
import { Modal, Box, Button } from '@mui/material';
import PropTypes from 'prop-types';
import { AUDIO_PAPER_TYPE } from '../../data/common';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import PlusIc from '../../assets/images/ic_plus_black.svg';
import MinusIc from '../../assets/images/ic_minus_black.svg';

const radioStyle = {
  color: '#000',
  '&.Mui-checked': {
    color: '#000',
  },
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '475px',
  height: '455px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '40px 40px 30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
};

function RecordSetModal({
  open,
  setOpen,
  setAudioType,
  setAudioGapAmount,
  setHideTestPaper,
}) {
  const [type, setType] = useState(AUDIO_PAPER_TYPE.ENG);
  const [count, setCount] = useState(5);

  const handleSave = () => {
    setAudioType(type);
    setAudioGapAmount(count);
    setOpen(false);
    setHideTestPaper(true);
  };

  return (
    <Modal open={open} onClose={() => setOpen(null)}>
      <Box sx={style}>
        <div className="w-full flex flex-col items-center justify-between text-[14px] font-[400]">
          <div className="font-[700] text-[18px] w-full flex justify-center mb-[24px]">
            음원 문제 유형 설정
          </div>
          <div className="w-full mb-[20px]">
            <FormControl>
              <RadioGroup
                value={type}
                defaultValue={AUDIO_PAPER_TYPE.ENG}
                onChange={e => setType(Number(e.target.value))}
              >
                <FormControlLabel
                  value={AUDIO_PAPER_TYPE.ENG}
                  control={<Radio sx={radioStyle} size="small" />}
                  label="듣고 영단어 쓰기"
                  sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
                <FormControlLabel
                  value={AUDIO_PAPER_TYPE.KOR}
                  control={<Radio sx={radioStyle} size="small" />}
                  label="듣고 한글 뜻 쓰기"
                  sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
                <FormControlLabel
                  value={AUDIO_PAPER_TYPE.ENG_KOR}
                  control={<Radio sx={radioStyle} size="small" />}
                  label="듣고 영단어 + 한글 뜻 쓰기"
                  sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="w-full flex flex-col justify-center items-center h-[138px] bg-[#F1F5F9] mb-[24px]">
            <div className="mb-[16px]">단어 사이 간격 설정</div>
            <div className="flex items-center justifyt-center gap-2">
              <Button
                variant="gray"
                sx={{ width: '48px', height: '48px' }}
                onClick={() => {
                  if (count === 0) return;
                  setCount(prev => prev - 1);
                }}
              >
                <img src={MinusIc} alt="minus" />
              </Button>
              <div className="flex items-center justify-center gap-2 w-[70px] mx-[20px]">
                <span className="text-right w-[45px] font-[700] text-[36px]">
                  {count}
                </span>
                <span className="text-[16px] font-[400]">초</span>
              </div>
              <Button
                variant="gray"
                sx={{ width: '48px', height: '48px' }}
                onClick={() => setCount(prev => prev + 1)}
              >
                <img src={PlusIc} alt="plus" />
              </Button>
            </div>
          </div>
        </div>
        <div className="flex w-full items-center justify-center gap-2">
          <Button
            variant="dark"
            onClick={() => {
              setOpen(false);
            }}
            sx={{ width: '113px' }}
          >
            닫기
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{ width: '113px' }}
          >
            설정완료
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

RecordSetModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  setAudioType: PropTypes.func.isRequired,
  setAudioGapAmount: PropTypes.func.isRequired,
  setHideTestPaper: PropTypes.func.isRequired,
};

export default RecordSetModal;
